import { Box, Button, Dialog, DialogContent, DialogTitle, IconButton } from "@material-ui/core";
import { Close } from "@material-ui/icons";
import { Alert } from "@material-ui/lab";
import { Scanner } from "@yudiel/react-qr-scanner";
import { useSnackbar } from "notistack";
import { Dispatch, SetStateAction, useState } from "react";
import { useTranslation } from "react-i18next";

type Props = {
  open: boolean;
  setOpen: Dispatch<SetStateAction<boolean>>;
  onScan: (value: string) => void;
};

const EanByBarcode = ({ open, setOpen, onScan }: Props) => {
  const { t } = useTranslation();
  const { enqueueSnackbar } = useSnackbar();
  const [alertData, setAlertData] = useState<string | null>(null);

  const handleScan = (data: any) => {
    if (data) {
      try {
        if (data?.[0]) {
          onScan(data[0]?.rawValue);
          setOpen(false);
        }
      } catch (error: any) {
        setAlertData(t("qrCode.errorBar"));
      }
    }
  };

  function onClose() {
    setOpen(false);
    setAlertData(null);
  }

  return (
    <Dialog
      fullWidth
      maxWidth="sm"
      open={open}
      onClose={() => onClose()}
      PaperProps={{ style: { margin: 8, width: "100%" } }}
    >
      <DialogTitle style={{ paddingBottom: 4, padding: "16px 12px 0 12px" }}>
        <Box display="flex" alignItems="center" justifyContent="space-between">
          <span>{t("qrCode.titleBar")}</span>
          <IconButton size="small" onClick={() => onClose()}>
            <Close />
          </IconButton>
        </Box>
      </DialogTitle>
      <DialogContent style={{ padding: 12 }}>
        {alertData ? (
          <Box display="flex" flexDirection="column" gridGap={16}>
            <Alert severity="warning" variant="filled" style={{ borderRadius: 10 }}>
              {alertData}
            </Alert>
            <Button onClick={() => setAlertData(null)} style={{ marginBottom: 8 }}>
              {t("qrCode.newBarcode")}
            </Button>
          </Box>
        ) : (
          <Box display="flex" justifyContent="center" alignItems="center" height="100%">
            <Box width="100%" style={{ aspectRatio: "1 / 1" }}>
              <Scanner
                formats={["ean_13"]}
                allowMultiple={false}
                onError={() => enqueueSnackbar(t("qrCode.access"), { variant: "warning" })}
                onScan={result => handleScan(result)}
              />
            </Box>
          </Box>
        )}
      </DialogContent>
    </Dialog>
  );
};

export default EanByBarcode;
